import { WEBSITE } from "~landing/seo/constants";

/**
 * Emits site-wide WebSite JSON-LD. next-seo 6.x ships no `WebSiteJsonLd`
 * component, so this renders the schema directly. Intentionally minimal
 * (name + url, no SearchAction) — see `WEBSITE` in `constants.ts`.
 */
export function WebSiteSchema() {
	const schema = {
		"@context": "https://schema.org",
		"@type": "WebSite",
		name: WEBSITE.name,
		url: WEBSITE.url,
	};

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
		/>
	);
}
